import React, { useState } from "react";
import { Upload, Button, message } from "antd";

import { apiURL, apiPrefix } from "../../../utlis/config";
import store from "store";
const Uploader = (propsInfo) => {
  const [fileList, updateFileList] = useState([]);
  const { pdfFileUrl, onChangePdf, onChangePdfName } = propsInfo;
  const props = {
    // fileList: pdfFileUrl || [],
    beforeUpload: (file) => {
      if (file.type !== "application/pdf") {
        message.error(`${file.name} is not a pdf file`);
      }
      return file.type === "application/pdf";
    },
    // onChange: (info) => {
    //   console.log(info.fileList);
    //   // file.status is empty when beforeUpload return false
    //   //   updateFileList(info.fileList.filter((file) => !!file.status));
    // },
    name: "file",
    multiple: false,
    action: `${apiURL}${"/media"}`,
    headers: {
      Authorization: `Bearer ${store.get("authToken")}`,
    },
    onChange(info) {
      console.log({ info });
      const { status, response, name } = info.file;
      if (status !== "uploading") {
      }
      if (status === "done") {
        if (!response.error && response.status === 200) {
          console.log({ name, response: apiURL + response.data });
          // imageUrl = response.data;
          onChangePdf(response.data);
          onChangePdfName(name);
        }
      } else if (status === "error") {
        // that.showErrorMessage("Uploading failed. Please try again");
      }
    },
  };
  return (
    <div id="pdf">
      <Upload {...props}>
        <Button style={{ padding: "6px 25px", height: "38px" }}>
          <i
            className="fa fa-upload"
            aria-hidden="true"
            style={{ padding: 6 }}
          />
          {pdfFileUrl ? "Update Pdf only" : "Upload Pdf only"}
        </Button>
      </Upload>
    </div>
  );
};
export default Uploader;
